import { Alert, Button, Card, Checkbox, Col, Form, Icon, Input, Modal, Row, Select, Spin, Table, Tooltip, Upload, message } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import DocumentList from "../../components/DocumentList";
import SubList from '../../components/SubList';
import InlineCreateMasterModal from "../../components/InlineCreateMasterModal";

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documentData: [],
      uploadFile: true,
      count: 1,
      fileList: [],
      file: null,
      loading: false,
      showUploadList: false,
      isTagDevice: false,
      availableMeters: [],
      createdAssetSubTypes: [],
      createdAssetMakes: [],
      fuelRateHistoryModalVisible: false,
    };
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        isTagDevice: this.isAnyDeviceTagSelected(nextProps.data),
        availableMeters: nextProps && nextProps.data && nextProps.data.meters || []
      })

    }

    const currentMeterField = this.props.form.getFieldValue('meters') || [];
    const nextMeterField = nextProps.form.getFieldValue('meters') || [];
    const isFiltersChanged = JSON.stringify(nextProps.filters || {}) !== JSON.stringify(this.props.filters || {});
    const isMetersChanged = JSON.stringify(nextMeterField) !== JSON.stringify(currentMeterField);

    if (isFiltersChanged && nextMeterField.length) {
      this.handleMeterChange(nextMeterField, nextProps.filters);
    } else if (isMetersChanged && nextMeterField.length) {
      this.handleMeterChange(nextMeterField, nextProps.filters);
    }
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);
      const { documentData } = this.state;
      const isEditMode = this.props.title === 'EDIT';
      if (typeof data.modelNumber === 'string') {
        data.modelNumber = data.modelNumber.trim();
        if (!data.modelNumber && !isEditMode) {
          delete data.modelNumber;
        }
      }
      const toNullableNumber = (value) => {
        if (value === '' || value === null || value === undefined || value === 'null' || value === 'undefined') {
          return null;
        }
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
      };
      const dimensionLengthMm = data.dimensionLengthMm;
      const dimensionWidthMm = data.dimensionWidthMm;
      const dimensionHeightMm = data.dimensionHeightMm;
      const hasDimensionFieldsPresent = ['dimensionLengthMm', 'dimensionWidthMm', 'dimensionHeightMm']
        .some((field) => Object.prototype.hasOwnProperty.call(data, field));
      if (hasDimensionFieldsPresent) {
        const lengthMm = toNullableNumber(dimensionLengthMm);
        const widthMm = toNullableNumber(dimensionWidthMm);
        const heightMm = toNullableNumber(dimensionHeightMm);
        const hasAnyDimensionValue = [lengthMm, widthMm, heightMm].some((value) => value !== null);
        const dimensionPayload = hasAnyDimensionValue ? { lengthMm, widthMm, heightMm } : null;
        data.dimension = dimensionPayload === null ? 'null' : JSON.stringify(dimensionPayload);
      }
      ['dimensionLengthMm', 'dimensionWidthMm', 'dimensionHeightMm', 'lengthMm', 'widthMm', 'heightMm', 'dimension.lengthMm', 'dimension.widthMm', 'dimension.heightMm']
        .forEach((field) => { delete data[field]; });

      if (this.isAssetModelCreateMode()) {
        const generatedName = this.getGeneratedAssetModelName({
          assetSubType: data.assetSubType,
          assetMake: data.assetMake,
          modelNumber: data.modelNumber || '',
        });
        if (!generatedName) {
          message.error('Please select Asset Sub Type and Make to generate the Asset Model Name.');
          return;
        }
        data.name = generatedName;
      }

      // data.documents = documentData;
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      if (data.standardFuelConsumptionRate)
        data.standardFuelConsumptionRate = JSON.stringify(data.standardFuelConsumptionRate)

      if (data.fuelMileageThreshold)
        data.fuelMileageThreshold = JSON.stringify(data.fuelMileageThreshold)

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  customUpload = file => {
    this.setState(state => ({
      fileList: [file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  handleChange = async info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
    if (info.file) {
      await this.getBase64(info.file, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  isAnyDeviceTagSelected = (source = {}) => {
    const flags = ['isTagDevice', 'isFuelSensorDevice', 'isRfidTag', 'isBleTag'];
    return flags.some((flag) => !!(source && source[flag]));
  }

  onChangeDeviceFlag = (field, checked) => {
    const flags = ['isTagDevice', 'isFuelSensorDevice', 'isRfidTag', 'isBleTag'];
    const isAnySelected = flags.some((flag) => {
      if (flag === field) {
        return !!checked;
      }
      return !!this.props.form.getFieldValue(flag);
    });
    this.setState({
      isTagDevice: isAnySelected
    });
  }

  getValueId = (value) => {
    if (!value) return null;
    if (typeof value === 'string' || typeof value === 'number') return `${value}`;
    if (typeof value === 'object') {
      const id = value._id || value.id;
      if (id) return `${id}`;
      if (value.toString && value.toString() !== '[object Object]') {
        return `${value.toString()}`;
      }
    }
    return null;
  }

  getMeterOptionDocs = (filters = this.props.filters) => {
    const docsFromStdRate = filters &&
      filters.standardFuelConsumptionRate &&
      filters.standardFuelConsumptionRate.schema &&
      filters.standardFuelConsumptionRate.schema.perType &&
      filters.standardFuelConsumptionRate.schema.perType.data &&
      filters.standardFuelConsumptionRate.schema.perType.data.data;

    if (Array.isArray(docsFromStdRate) && docsFromStdRate.length) {
      return docsFromStdRate;
    }

    const docsFromMeters = filters && filters.meters && filters.meters.data && filters.meters.data.data;
    if (Array.isArray(docsFromMeters) && docsFromMeters.length) {
      return docsFromMeters;
    }

    return [];
  }

  handleMeterChange = (mtrs = [], filtersArg = null) => {
    try {
      const hasFilterShape = !!(filtersArg && (filtersArg.standardFuelConsumptionRate || filtersArg.meters));
      const activeFilters = hasFilterShape ? filtersArg : this.props.filters;
      const selectedMeterIds = (mtrs || []).map(this.getValueId).filter(Boolean);
      const meterDocs = this.getMeterOptionDocs(activeFilters);
      const availableMeters = meterDocs.filter((meterDoc) => selectedMeterIds.includes(this.getValueId(meterDoc)));
      this.setState({ availableMeters });
    } catch (e) {
      console.error(e);
      this.setState({ availableMeters: [] });
    }
  }

  getArrayFieldValue = (fieldName) => {
    const formValues = this.props.form.getFieldValue(fieldName);
    if (Array.isArray(formValues)) {
      return formValues;
    }
    const dataValues = this.props.data && this.props.data[fieldName];
    return Array.isArray(dataValues) ? dataValues : [];
  }

  getPerTypeIds = (list = []) => {
    const ids = [];
    list.forEach((doc) => {
      const perTypeId = this.getValueId(doc && doc.perType);
      if (perTypeId && !ids.includes(perTypeId)) {
        ids.push(perTypeId);
      }
    });
    return ids;
  }

  getSelectedMeterIds = () => {
    const selectedMeters = this.getArrayFieldValue('meters');
    const selectedIds = [];
    selectedMeters.forEach((meter) => {
      const meterId = this.getValueId(meter);
      if (meterId && !selectedIds.includes(meterId)) {
        selectedIds.push(meterId);
      }
    });
    return selectedIds;
  }

  getStandardAvailableMeters = (filters = this.props.filters) => {
    const selectedMeterIds = this.getSelectedMeterIds();
    const meterDocs = this.getMeterOptionDocs(filters);
    if (!selectedMeterIds.length || !meterDocs.length) {
      return [];
    }
    return meterDocs.filter((meterDoc) => selectedMeterIds.includes(this.getValueId(meterDoc)));
  }

  getThresholdAvailableMeters = (meters = []) => {
    const standardRates = this.getArrayFieldValue('standardFuelConsumptionRate');
    const selectedPerTypeIds = this.getPerTypeIds(standardRates);
    return (meters || []).filter((meter) => selectedPerTypeIds.includes(this.getValueId(meter)));
  }

  toggleFuelRateHistoryModal = (visible) => {
    this.setState({ fuelRateHistoryModalVisible: visible });
  }

  formatHistoryDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString();
  }

  getFuelRateHistoryColumns = () => [
    {
      title: 'Meter',
      dataIndex: 'perType',
      key: 'perType',
      render: (perType) => (perType && perType.name) || '-',
    },
    {
      title: 'Fuel Qty (Rate)',
      dataIndex: 'fuelQty',
      key: 'fuelQty',
    },
    {
      title: 'Effective From',
      dataIndex: 'effectiveFrom',
      key: 'effectiveFrom',
      render: this.formatHistoryDate,
    },
    {
      title: 'Effective To',
      dataIndex: 'effectiveTo',
      key: 'effectiveTo',
      render: this.formatHistoryDate,
    },
    {
      title: 'Changed By',
      dataIndex: 'changedBy',
      key: 'changedBy',
      render: (changedBy) => (changedBy && (changedBy.name || changedBy.email)) || '-',
    },
  ]

  renderFuelRateHistorySection = (data) => {
    const history = (data && data.standardFuelConsumptionRateHistory) || [];
    if (!history.length) {
      return null;
    }
    return (
      <React.Fragment>
        <Form.Item>
          <Button onClick={() => this.toggleFuelRateHistoryModal(true)}>
            Show Standard Rate History
          </Button>
        </Form.Item>
        <Modal
          title="Standard Fuel Consumption Rate History"
          visible={this.state.fuelRateHistoryModalVisible}
          onCancel={() => this.toggleFuelRateHistoryModal(false)}
          footer={null}
          width={720}
        >
          <Table
            rowKey={(record, index) => index}
            columns={this.getFuelRateHistoryColumns()}
            dataSource={history}
            pagination={false}
            size="small"
          />
        </Modal>
      </React.Fragment>
    );
  }

  isAssetModelCreateMode = () => this.props.resource === 'AssetModel' && this.props.title === 'CREATE'
  isAssetModelNameManagedMode = () => this.props.resource === 'AssetModel' && (this.props.title === 'CREATE' || this.props.title === 'EDIT')

  getMergedOptionsByField = (field, filters = this.props.filters) => {
    const baseOptions = filters && filters[field] && filters[field].data && filters[field].data.data || [];
    if (field === 'assetSubType') {
      return this.mergeUniqueOptions(baseOptions, this.state.createdAssetSubTypes);
    }
    if (field === 'assetMake') {
      return this.mergeUniqueOptions(baseOptions, this.state.createdAssetMakes);
    }
    return baseOptions;
  }

  getOptionNameById = (field, selectedId, filters = this.props.filters) => {
    if (!selectedId || !filters || !filters[field]) {
      return '';
    }
    const selectedIdValue = `${selectedId}`;
    const options = this.getMergedOptionsByField(field, filters);
    const selectedOption = options.find((option) => `${option && option._id}` === selectedIdValue);
    return selectedOption && selectedOption.name || '';
  }

  composeAssetModelName = (assetMakeName = '', assetSubTypeName = '', modelNumber = '') => {
    const normalizedModelNumber = modelNumber && modelNumber.toString().trim() || '';
    const nameParts = [(assetMakeName || '').trim(), (assetSubTypeName || '').trim()];
    if (normalizedModelNumber) {
      nameParts.push(normalizedModelNumber);
    }
    return nameParts.filter(Boolean).join(' ');
  }

  getGeneratedAssetModelName = (values = {}) => {
    const assetSubTypeName = this.getOptionNameById('assetSubType', values.assetSubType);
    const assetMakeName = this.getOptionNameById('assetMake', values.assetMake);
    return this.composeAssetModelName(assetMakeName, assetSubTypeName, values.modelNumber);
  }

  onAssetSubTypeChange = () => {
    this.props.form.setFieldsValue({ assetMake: undefined });
  }

  mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
    const merged = [...(baseOptions || [])];
    (createdOptions || []).forEach((created) => {
      if (!created || !created._id) {
        return;
      }
      const alreadyExists = merged.find((option) => `${option && option._id}` === `${created._id}`);
      if (!alreadyExists) {
        merged.push(created);
      }
    });
    return merged;
  }

  handleAssetSubTypeCreated = (createdAssetSubType) => {
    if (!createdAssetSubType || !createdAssetSubType._id) {
      return;
    }
    this.setState((prevState) => {
      const exists = (prevState.createdAssetSubTypes || []).find((item) => `${item._id}` === `${createdAssetSubType._id}`);
      if (exists) {
        return null;
      }
      return { createdAssetSubTypes: [...(prevState.createdAssetSubTypes || []), createdAssetSubType] };
    });
    this.props.form.setFieldsValue({ assetSubType: createdAssetSubType._id, assetMake: undefined });
  }

  handleAssetMakeCreated = (createdAssetMake) => {
    if (!createdAssetMake || !createdAssetMake._id) {
      return;
    }
    this.setState((prevState) => {
      const exists = (prevState.createdAssetMakes || []).find((item) => `${item._id}` === `${createdAssetMake._id}`);
      if (exists) {
        return null;
      }
      return { createdAssetMakes: [...(prevState.createdAssetMakes || []), createdAssetMake] };
    });
    this.props.form.setFieldsValue({ assetMake: createdAssetMake._id });
  }

  getLabelWithTooltip = (fieldConfig = {}, fallback = '') => {
    const label = sanitizeFieldName(fieldConfig.options && fieldConfig.options.label ? fieldConfig.options.label : fallback);
    return (
      <span>
        {label}&nbsp;
        {fieldConfig.options && fieldConfig.options.description ? (
          <Tooltip title={fieldConfig.options.description}>
            <Icon type="question-circle-o" />
          </Tooltip>
        ) : null}
      </span>
    );
  }

  renderDimensionPreview = (lengthMm, widthMm, heightMm) => {
    const parsedLength = Number(lengthMm) > 0 ? Number(lengthMm) : 0;
    const parsedWidth = Number(widthMm) > 0 ? Number(widthMm) : 0;
    const parsedHeight = Number(heightMm) > 0 ? Number(heightMm) : 0;
    const fallbackDimension = 1000;

    const rawLength = parsedLength || fallbackDimension;
    const rawWidth = parsedWidth || fallbackDimension;
    const rawHeight = parsedHeight || fallbackDimension;

    const maxDimension = Math.max(rawLength, rawWidth, rawHeight, 1);
    const normalizedLength = rawLength / maxDimension;
    const normalizedWidth = rawWidth / maxDimension;
    const normalizedHeight = rawHeight / maxDimension;

    const originX = 36;
    const originY = 146;
    const frontWidth = 58 + (normalizedLength * 72);
    const depth = 24 + (normalizedWidth * 50);
    const height = 36 + (normalizedHeight * 72);
    const depthOffsetX = depth * 0.78;
    const depthOffsetY = depth * 0.45;

    const A = { x: originX, y: originY };
    const B = { x: originX + frontWidth, y: originY };
    const C = { x: originX + frontWidth, y: originY - height };
    const D = { x: originX, y: originY - height };

    const E = { x: A.x + depthOffsetX, y: A.y - depthOffsetY };
    const F = { x: B.x + depthOffsetX, y: B.y - depthOffsetY };
    const G = { x: C.x + depthOffsetX, y: C.y - depthOffsetY };
    const H = { x: D.x + depthOffsetX, y: D.y - depthOffsetY };

    const fmtPoint = (p) => `${p.x},${p.y}`;
    const lengthLabelX = (A.x + B.x) / 2;
    const widthLabelX = ((B.x + F.x) / 2) + 12;
    const widthLabelY = ((B.y + F.y) / 2) - 8;
    const heightLineX = F.x + 14;
    const heightLabelY = (B.y + C.y) / 2;

    return (
      <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 12, background: '#fff' }}>
        <svg width="100%" height="190" viewBox="0 0 280 190" role="img" aria-label="Asset dimension preview">
          <defs>
            <marker id="dimensionArrow" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto-start-reverse">
              <path d="M 0 0 L 6 3 L 0 6 z" fill="#595959" />
            </marker>
          </defs>

          <polygon points={`${fmtPoint(A)} ${fmtPoint(B)} ${fmtPoint(F)} ${fmtPoint(E)}`} fill="#e6f7ff" stroke="#1890ff" strokeWidth="2" />
          <polygon points={`${fmtPoint(A)} ${fmtPoint(B)} ${fmtPoint(C)} ${fmtPoint(D)}`} fill="#f0f5ff" stroke="#1890ff" strokeWidth="2" />
          <polygon points={`${fmtPoint(B)} ${fmtPoint(F)} ${fmtPoint(G)} ${fmtPoint(C)}`} fill="#d6e4ff" stroke="#1890ff" strokeWidth="2" />
          <polygon points={`${fmtPoint(D)} ${fmtPoint(C)} ${fmtPoint(G)} ${fmtPoint(H)}`} fill="#ffffff" stroke="#1890ff" strokeWidth="2" />

          <line x1={A.x} y1={A.y + 14} x2={B.x} y2={B.y + 14} stroke="#595959" strokeWidth="1.5" markerStart="url(#dimensionArrow)" markerEnd="url(#dimensionArrow)" />
          <text x={lengthLabelX} y={A.y + 30} textAnchor="middle" fill="#262626" fontSize="11">
            L: {parsedLength || '-'} mm
          </text>

          <line x1={B.x + 6} y1={B.y + 2} x2={F.x + 6} y2={F.y + 2} stroke="#595959" strokeWidth="1.5" markerStart="url(#dimensionArrow)" markerEnd="url(#dimensionArrow)" />
          <text x={widthLabelX} y={widthLabelY} textAnchor="start" fill="#262626" fontSize="11">
            W: {parsedWidth || '-'} mm
          </text>

          <line x1={heightLineX} y1={B.y} x2={heightLineX} y2={C.y} stroke="#595959" strokeWidth="1.5" markerStart="url(#dimensionArrow)" markerEnd="url(#dimensionArrow)" />
          <text x={heightLineX + 6} y={heightLabelY} textAnchor="start" fill="#262626" fontSize="11">
            H: {parsedHeight || '-'} mm
          </text>
        </svg>
      </div>
    );
  }

  renderDimensionSection = (filters, getFieldDecorator, data, form) => {
    const getDimensionFieldConfig = (schemaField, fallbackLabel) => {
      const fieldConfig = (filters && (filters[schemaField] || filters[schemaField.split('.').pop()])) || {};
      return {
        required: !!fieldConfig.required,
        label: sanitizeFieldName(fieldConfig.options && fieldConfig.options.label ? fieldConfig.options.label : fallbackLabel),
        description: fieldConfig.options && fieldConfig.options.description ? fieldConfig.options.description : '',
      };
    };

    const dimensionFields = [
      {
        formKey: 'dimensionLengthMm',
        dataKey: 'lengthMm',
        config: getDimensionFieldConfig('dimension.lengthMm', 'Length (mm)'),
      },
      {
        formKey: 'dimensionWidthMm',
        dataKey: 'widthMm',
        config: getDimensionFieldConfig('dimension.widthMm', 'Width (mm)'),
      },
      {
        formKey: 'dimensionHeightMm',
        dataKey: 'heightMm',
        config: getDimensionFieldConfig('dimension.heightMm', 'Height (mm)'),
      },
    ];

    const lengthMm = form.getFieldValue('dimensionLengthMm');
    const widthMm = form.getFieldValue('dimensionWidthMm');
    const heightMm = form.getFieldValue('dimensionHeightMm');

    return (
      <Card
        type="inner"
        title="Asset Dimensions (Optional)"
        style={{ marginTop: 16, marginBottom: 16, background: '#fafafa', borderColor: '#d9d9d9' }}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            {dimensionFields.map((field) => {
              const initialValue = data && data.dimension && data.dimension[field.dataKey] !== undefined && data.dimension[field.dataKey] !== null
                ? data.dimension[field.dataKey]
                : (data && data[field.dataKey] !== undefined && data[field.dataKey] !== null ? data[field.dataKey] : undefined);
              return (
                <Form.Item
                  key={field.formKey}
                  label={<span>
                    {field.config.label}&nbsp;
                    {field.config.description ? (
                      <Tooltip title={field.config.description}>
                        <Icon type="question-circle-o" />
                      </Tooltip>
                    ) : null}
                  </span>}
                >
                  {getFieldDecorator(field.formKey, {
                    rules: [{
                      required: field.config.required,
                      message: `${field.config.label} is required!`
                    }],
                    initialValue,
                  })(
                    <Input
                      type='number'
                      min={0}
                      onWheel={event => event.currentTarget.blur()}
                      autoComplete={'off'}
                      placeholder={`Enter ${field.config.label}`}
                    />
                  )}
                </Form.Item>
              );
            })}
          </Col>
          <Col xs={24} md={12}>
            {this.renderDimensionPreview(lengthMm, widthMm, heightMm)}
          </Col>
        </Row>
      </Card>
    );
  }

  renderAssetModelNameSection = (filters, getFieldDecorator, data, form) => {
    if (!filters || !filters.assetSubType || !filters.assetMake) {
      return null;
    }

    const selectedSubType = form.getFieldValue('assetSubType');
    const generatedName = this.getGeneratedAssetModelName({
      assetSubType: selectedSubType,
      assetMake: form.getFieldValue('assetMake'),
      modelNumber: form.getFieldValue('modelNumber'),
    });
    const existingName = data && data.name ? data.name : '';
    const generatedNameLabel = existingName
      ? `Generated Asset Model Name (${existingName})`
      : 'Generated Asset Model Name';
    const modelNumberFilter = filters.modelNumber || {
      field: 'modelNumber',
      required: false,
      options: { label: 'Model Number' }
    };

    const assetSubTypeOptions = this.getMergedOptionsByField('assetSubType', filters);
    const assetMakeOptions = this.getMergedOptionsByField('assetMake', filters);

    return (
      <Card
        type="inner"
        style={{ marginBottom: 16, background: '#fafafa', borderColor: '#d9f7be' }}
      >
        <Alert
          type="info"
          showIcon
          message="Asset Model Name is generated automatically in the background"
          description="Sequence: Asset Sub Type -> Make -> Model Number (optional)."
          style={{ marginBottom: 16 }}
        />
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item key={'assetSubType'} label={this.getLabelWithTooltip(filters.assetSubType, 'assetSubType')}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {getFieldDecorator('assetSubType', {
                  rules: [{
                    required: filters.assetSubType.required,
                    message: `${sanitizeFieldName(filters.assetSubType.options && filters.assetSubType.options.label ? filters.assetSubType.options.label : 'assetSubType')} is required!`
                  }],
                  initialValue: data && data.assetSubType ? (data.assetSubType._id || data.assetSubType) : undefined,
                })(<Select
                  showSearch
                  allowClear
                  style={{ width: '80%' }}
                  placeholder="Please select Asset Sub Type"
                  onChange={this.onAssetSubTypeChange}
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                >
                  {(assetSubTypeOptions || []).map((option) =>
                    <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
                </Select>)}
                <InlineCreateMasterModal
                  item={'EquipmentSubType'}
                  onCreated={this.handleAssetSubTypeCreated}
                />
              </div>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item key={'assetMake'} label={this.getLabelWithTooltip(filters.assetMake, 'assetMake')}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {getFieldDecorator('assetMake', {
                  rules: [{
                    required: filters.assetMake.required,
                    message: `${sanitizeFieldName(filters.assetMake.options && filters.assetMake.options.label ? filters.assetMake.options.label : 'assetMake')} is required!`
                  }],
                  initialValue: data && data.assetMake ? (data.assetMake._id || data.assetMake) : undefined,
                })(<Select
                  showSearch
                  allowClear
                  style={{ width: '80%' }}
                  placeholder="Please select Make"
                  disabled={!selectedSubType}
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                >
                  {(assetMakeOptions || []).map((option) =>
                    <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
                </Select>)}
                <InlineCreateMasterModal
                  item={'AssetMake'}
                  onCreated={this.handleAssetMakeCreated}
                />
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item key={'modelNumber'} label={this.getLabelWithTooltip(modelNumberFilter, 'modelNumber')}>
          {getFieldDecorator('modelNumber', {
            rules: [{
              required: false,
            }],
            initialValue: data && data.modelNumber || '',
          })(<Input
            placeholder={`Please Enter ${sanitizeFieldName(modelNumberFilter.field || 'modelNumber')}`}
            autoComplete={'off'}
          />)}
        </Form.Item>

        <Form.Item key={'generatedName'} label={generatedNameLabel}>
          <Input
            value={generatedName || 'Will be generated after selecting Asset Sub Type and Make'}
            disabled
          />
        </Form.Item>
      </Card>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form } = this.props;
    const renderFilters = resource === 'AssetModel' && title === 'EDIT' && filters && filters.name ? {
      ...filters,
      name: {
        ...filters.name,
        options: {
          ...(filters.name.options || {}),
          disabledOnEdit: true,
        },
      },
    } : filters;
    const selectedMeterIds = this.getSelectedMeterIds();
    const standardAvailableMeters = this.getStandardAvailableMeters(renderFilters);
    const resolvedStandardMeters = standardAvailableMeters.length
      ? standardAvailableMeters
      : (!selectedMeterIds.length ? (this.state.availableMeters || []) : []);
    const thresholdAvailableMeters = this.getThresholdAvailableMeters(resolvedStandardMeters);
    const { imageUrl } = this.state;
    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    const isAssetModelNameManagedMode = this.isAssetModelNameManagedMode();
    const hiddenForAssetModelNameSection = ['name', 'assetSubType', 'assetMake', 'modelNumber'];
    const assetModelDimensionFields = ['dimension', 'dimension.lengthMm', 'dimension.widthMm', 'dimension.heightMm', 'lengthMm', 'widthMm', 'heightMm'];
    const alwaysHiddenFields = ['standardFuelConsumptionRateHistory'];
    const formFieldKeys = Object.keys(renderFilters || {}).filter((field) => {
      if (alwaysHiddenFields.includes(field)) {
        return false;
      }
      if (isAssetModelNameManagedMode && hiddenForAssetModelNameSection.includes(field)) {
        return false;
      }
      if (resource === 'AssetModel' && assetModelDimensionFields.includes(field)) {
        return false;
      }
      return true;
    });
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {isAssetModelNameManagedMode ? this.renderAssetModelNameSection(renderFilters, getFieldDecorator, data, form) : null}
            {formFieldKeys.map((item) => {
              // console.log('item:', item, 'filters[item]:', filters[item])
              if (renderFilters[item].type === 'Array' && renderFilters[item].schema) {
                const isStandardFuelRate = item === 'standardFuelConsumptionRate';
                const isFuelMileageThreshold = item === 'fuelMileageThreshold';

                const shouldHideAddButton =
                  (isStandardFuelRate && !resolvedStandardMeters.length) ||
                  (isFuelMileageThreshold && !thresholdAvailableMeters.length);

                let other = null;
                if (isStandardFuelRate) {
                  other = {
                    key: 'standardFuelConsumptionRate',
                    availableMeters: resolvedStandardMeters,
                    enforceUniquePerType: true,
                    limitByAvailableOptions: true,
                  };
                } else if (isFuelMileageThreshold) {
                  other = {
                    key: 'fuelMileageThreshold',
                    availableMeters: thresholdAvailableMeters,
                    enforceUniquePerType: true,
                    limitByAvailableOptions: true,
                  };
                }

                return <SubList key={item} item={renderFilters[item]} form={form} data={data[item]} title={title}
                  resource={resource} hideAddButton={shouldHideAddButton}
                  onChange={(s, x) => console.log(s, x)}
                  other={other}
                />
              } else {
                if (item === 'documents') {
                  return <DocumentList match={this.props.match} history={this.props.history} key={item}
                    item={renderFilters[item]} form={form} data={data[item]}
                    subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData} />
                } else if (item === 'subAssembly') {
                  return (
                    <Form.Item key={'subAssembly'} label={'Sub Assembly'}>
                      {getFieldDecorator(`subAssembly`, {
                        initialValue: data && data.subAssembly && data.subAssembly.map(c => c._id),
                      })
                        (<Select
                          showSearch
                          mode="multiple"
                          style={{ width: '100%' }}
                          filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                          }
                          onSearch={this.props.fetchSpare}
                          placeholder={`Please Enter Sub Assembly`}
                        >
                          {(renderFilters[item].data.data || []).map(item =>
                            <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                        </Select>)
                      }
                    </Form.Item>);
                } else if (item === 'meters') {
                  return (
                    <Form.Item key={item}
                      label={<span>
                        {sanitizeFieldName(renderFilters[item].options.label ? renderFilters[item].options.label : item)}&nbsp;
                        {renderFilters[item].options.description ? (
                          <Tooltip title={renderFilters[item].options.description}>
                            <Icon type="question-circle-o" />
                          </Tooltip>)
                          : null}
                      </span>}>
                      {getFieldDecorator(item, {
                        rules: [{
                          required: renderFilters[item].required,
                          message: `${sanitizeFieldName(renderFilters[item].options.label ? renderFilters[item].options.label : item)} is required!`
                        }],
                        initialValue: (data && data.meters && data.meters.length) ? data.meters.map(field => field._id) : [],
                      })(<Select
                        showSearch
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Please select"
                        onChange={this.handleMeterChange}
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                      >
                        {renderFilters[item].data.data.map(itm => <Select.Option key={itm._id}
                          value={itm._id}>{itm.role ? itm.role : renderFilters[item].options && renderFilters[item].options.main ? itm[renderFilters[item].options.main] : itm.name}</Select.Option>)}
                      </Select>)
                      }
                    </Form.Item>
                  )

                } else if (['isTagDevice', 'isFuelSensorDevice', 'isRfidTag', 'isBleTag'].includes(item)) {
                  return (
                    <Form.Item key={item}
                      label={
                        <span>{sanitizeFieldName(renderFilters[item].options.label ? renderFilters[item].options.label : item)}&nbsp;
                          {renderFilters[item].options.description ?
                            (<Tooltip title={renderFilters[item].options.description}>
                              <Icon type="question-circle-o" />
                            </Tooltip>) : null}</span>}>
                      {getFieldDecorator(item, {
                        rules: [{
                          required: !renderFilters[item].requiredAtAdmin ? renderFilters[item].requiredAtAdmin : renderFilters[item].required,
                          message: `${sanitizeFieldName(renderFilters[item].options.label ? renderFilters[item].options.label : item)} is required!`
                        }],
                        valuePropName: 'checked',
                        initialValue: !!(data && data[item]),
                      })(<Checkbox onChange={(e) => this.onChangeDeviceFlag(item, e && e.target && e.target.checked)} />)
                      }
                    </Form.Item>);
                } else if (item === 'deviceType' && this.state.isTagDevice)
                  return getFormFieldByType(renderFilters, item, getFieldDecorator, data, { resource: resource, title: title });
                else if (item === 'tagType' && this.state.isTagDevice)
                  return getFormFieldByType(renderFilters, item, getFieldDecorator, data, { resource: resource, title: title });
                else if (item !== 'deviceType' && item !== 'tagType') {
                  if (item === 'idealFuelConsumptionRate' && form.getFieldValue('fuelType'))
                    return getFormFieldByType(renderFilters, item, getFieldDecorator, data, { resource: resource, title: title });
                  else if (item === 'acceptableIdleTime') {
                    // console.log('data:', data)
                    if (!data || data['acceptableIdleTime'] === undefined || data['acceptableIdleTime'] === null)
                      data['acceptableIdleTime'] = 5;
                    // console.log('data after:', data)
                    return getFormFieldByType(renderFilters, item, getFieldDecorator, data, { resource: resource, title: title });
                  }
                  else if (item !== 'idealFuelConsumptionRate')
                    return getFormFieldByType(renderFilters, item, getFieldDecorator, data, { resource: resource, title: title });

                }
              }
            })}
            <Form.Item key={'files'} label="Upload Icon">
              {getFieldDecorator('files', {
                rules: [{ required: false }],
                initialValue: (data && data['file']) ? data['file'] : []
              })(
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  name="files"
                  onChange={this.handleChange}
                  showUploadList={false}
                  beforeUpload={this.customUpload}
                  fileList={this.state.fileList}
                >
                  {/*upload*/}
                  {imageUrl || data && data.icon ?
                    <img src={imageUrl || data.icon} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              )}
            </Form.Item>
            {resource === 'AssetModel' ? this.renderDimensionSection(renderFilters, getFieldDecorator, data, form) : null}
            {this.renderFuelRateHistorySection(data)}
            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
